import React, { useEffect } from "react";
import "./Popup/popup.sass";

const Popup = ({ active, setActive, children }) => {
  useEffect(() => {
    if (active) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [active]);

  if (!active) return null;

  return (
    <div className="popup active" onClick={() => setActive(false)}>
      <div className="popup__content" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};

export default Popup;